import React from 'react';
import { createRoot } from 'react-dom/client';

import 'intl';
import 'intl/locale-data/jsonp/de-DE';
import { Application } from './src/Application';

// eslint-disable-next-line unicorn/prefer-query-selector
const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
const root = createRoot(container!);
root.render(<Application />);
